import React from "react";
import ReactDOM from 'react-dom';
import {makeObservable, observable, computed} from "mobx";
import {observer} from 'mobx-react';
import _ from 'lodash';

class ModalHolder {
  stack;
  id;
  component;
  accept;
  reject;

  constructor(stack, accept, reject) {
    this.stack = stack;
    this.id = _.uniqueId();
    this.accept = accept;
    this.reject = reject;
  }

  close = () => {
    this.stack.remove(this);
    this.reject();
  };

  confirm = (...args) => {
    this.stack.remove(this);
    this.accept(...args);
  };
}

class ModalStack {
  stack = [];

  constructor() {
    makeObservable(this, {
        stack: observable
    });
  }

  add(factory) {
    return new Promise((accept, reject) => {
      const holder = new ModalHolder(this, accept, reject);
      holder.component = factory(holder.close, holder.confirm);
      this.stack.push(holder);
    });
  }

  remove(holder) {
    _.remove(this.stack, item => item == holder);
  }
}

const ModalStackView = observer(
    class ModalStackView extends React.Component {
      render() {
        return (
          <div>
            {this.props.stack.stack.map(item => (
              <div key={item.id}>
                {item.component}
              </div>
            ))}
          </div>
        )
      }
    }
);

export const stack = new ModalStack();
const container = document.createElement('div');
document.body.appendChild(container);
ReactDOM.render(<ModalStackView stack={stack}/>, container);

export default stack.add.bind(stack);